import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { map, switchMap } from 'rxjs';

import { PermissionsDataService } from '../infrastructure/permissions-data.service';

import * as AccessControlActions from './access-control.actions';

@Injectable()
export class AccessControlEffects {
    private readonly actions$ = inject(Actions);
    private readonly permissionsDataService = inject(PermissionsDataService);

    loadPermissions$ = createEffect(() =>
        this.actions$.pipe(
            ofType(AccessControlActions.loadPermissions),
            switchMap(({ role }) =>
                this.permissionsDataService
                    .getPermissions(role)
                    .pipe(map((response) => AccessControlActions.loadPermissionsSuccess(response)))
            )
        )
    );
}
